import React from 'react';
import PropTypes from 'prop-types';
import { Img } from 'react-image';
import styled from 'styled-components';

import { recordStatisticsEvent } from '../../../../services/statistics-service';
import Avatar from '../../avatar';
import { SectionTitle } from '../styles';
import { defaultFundManagerTitle } from '../../consts';

const Container = styled(SectionTitle)`
  display: flex;
  flex-direction: column;
  ${props => (!props.theme.isXLarge && !props.theme.isMobileOrTablet) && `
    /* large and medium breakpoints, i.e. 569~1024px */
    &&& {
      margin-top: -24px;
    }
  `};
`;

const Logo = styled(Img)`
  width: 76px;
  height: 21px;
`;

const Headline = styled.span`
  margin-top: 20px;
`;

const SubHeadline = styled.span`
  margin-top: 10px;
  text-transform: none;
  && {
    font-size: 21px;
    font-weight: ${props => props.theme.fontWeightRegular};
    line-height: 130%;
  }
`;

const Manager = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
  margin-top: 32px;

  & > a {
    height: 60px;
  }
  & > a > img {
    width: 60px;
    height: 60px;
    min-width: 60px;
    margin-right: 16px;
    border: 2px solid #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 4px 8px rgba(50, 50, 71, 0.2);
    border-radius: 6px;
  }
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: none;
`;

const Name = styled.a`
  font: ${props => props.theme.fontWeightBold} 19px/21px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
`;

const Position = styled.span`
  margin-top: 2px;
  font: ${props => props.theme.fontWeightegular} 16px/19px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
`;

export default function Title({ fund, manager, livewireLogo }) {
  const handleClick = e => {
    let { target } = e;

    while (!target.getAttribute('href')) {
      target = target.parentElement;
    }

    recordStatisticsEvent({
      id: fund.id,
      statisticable: 'fund',
      event: 'fund_profile_contributor_view',
      clicked_url: target.getAttribute('href'),
      page: `${window.location.pathname}#fund-manager-qanda`,
    });

    return false;
  };

  return (
    <Container>
      <Logo src={livewireLogo} />
      <Headline>Manager Q&amp;A</Headline>
      <SubHeadline>Introducing, LW&apos;s exclusive Q&amp;A with the manager</SubHeadline>
      {!!manager && (
      <Manager>
        <Avatar {...manager} clickHandler={handleClick} />
        <NameContainer>
          <Name href={`/contributors/${manager.slug}`} onClick={handleClick}>
            {manager.name}
          </Name>
          {!!manager.position && <Position>{manager.position}</Position>}
          {!manager.position && <Position>{defaultFundManagerTitle}</Position>}
        </NameContainer>
      </Manager>
      )}
    </Container>
  );
}

Title.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  manager: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string.isRequired,
    position: PropTypes.string,
  }).isRequired,
  livewireLogo: PropTypes.string.isRequired,
};
